import { useState } from 'react'

export const useTestingForms = () => {
  const [inFormGroup] = useState<boolean>(true)

  // useEffect(() => {
  //   let localValue = localStorage.getItem('inFormGroup')
  //   if (!localValue) {
  //     localValue = (Math.floor(Math.random() * 2) === 1).toString()
  //     localStorage.setItem('inFormGroup', localValue)
  //   }
  //   setInFormGroup(localValue === 'true')
  // }, [])

  return {
    inFormGroup,
    variation: inFormGroup ? 'email_optional' : 'control',
  }
}
